interface ContactData {
  id: string;
  phone: string;
  email: string;
  adress: string;
  vat: string;
}

export async function updateContact(info: ContactData) {
  const response = await fetch(`/api/update-contact`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(info),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(`Error updating contact: ${response.statusText} - ${error}`);
  }

  return response.json();
}
